import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPromptsPageEdit from "../../../views/admin/prompts";
import AdminTemplateList from "../../../views/admin/template/list";

const AdminTemplatePageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
      <AdminTemplateList />
      <AdminFooter />
    </div>
  );
};

export default AdminTemplatePageList;
